import React from 'react';
import { I18n } from 'react-redux-i18n';
import { Table } from 'semantic-ui-react';
import { retentionRules } from './constants';
import styles from './RetentionPanel.module.css';

interface RetentionSkeletonProps {
  // A subject with no account of its own (guest donor or ticket buyer, lead, event ambassador)
  // has no login rule, so it renders one row fewer. The caller knows this before the request
  // resolves - the account header always has an account, and the grid row carries an accountId.
  hasAccount?: boolean;
}

// Height comes from the real label text, not from a fixed bar height, because the loaded row is
// not a constant: 36.09px in the account header, 34.3px in the wider modal. The label is
// rendered for real (same font, same wrapping) with transparent text, and the visible bar is
// drawn behind it, so the placeholder is exactly as tall as the content it replaces in any
// context. The two columns are spanned into one cell so column widths are left alone.
const RetentionSkeleton = ({ hasAccount = true }: RetentionSkeletonProps) => {
  const rows = hasAccount
    ? retentionRules
    : retentionRules.filter((rule) => rule.rule !== 'login');

  return (
    <Table
      basic="very"
      compact
      size="small"
      unstackable
      data-testid="retention-skeleton"
    >
      <Table.Body>
        {rows.map((rule) => (
          <Table.Row className={styles.row} key={rule.rule}>
            <Table.Cell colSpan={2}>
              <span className={styles.lineWrap} aria-hidden="true">
                <span className={styles.iconSlot} />
                <span className={styles.line}>{I18n.t(rule.labelKey)}</span>
              </span>
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

export default RetentionSkeleton;
